<template>
  <div class="keycloak-callback">
    <q-linear-progress v-if="loading" indeterminate />
    <p v-if="error" class="keycloak-callback__error">{{ error }}</p>
    <p v-if="!loading && !error">Перенаправление...</p>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { PAGES } from "@/constants";
import cookiesService from "@/services/cookiesService";
import { useAppStore } from "@/services/store/app";

const loading = ref(true);
const error = ref("");

const router = useRouter();
const appStore = useAppStore();
const cookiesServiceInstance = cookiesService.getService();

function parseQueryOrHash(str) {
  if (!str) return {};
  if (str.charAt(0) === "?" || str.charAt(0) === "#") str = str.slice(1);
  const params = {};
  str.split("&").forEach((part) => {
    const eq = part.indexOf("=");
    if (eq === -1) return;
    const key = decodeURIComponent(part.slice(0, eq).replace(/\+/g, " "));
    const value = decodeURIComponent((part.slice(eq + 1) || "").replace(/\+/g, " "));
    if (key) params[key] = value;
  });
  return params;
}

onMounted(() => {
  const fromQuery = parseQueryOrHash(window.location.search || "");
  const fromHash = parseQueryOrHash(window.location.hash || "");
  const params = { ...fromHash, ...fromQuery };
  const err = params.error;
  const access = params.access;
  const refresh = params.refresh;
  if (err) {
    // Тихий SSO без активной сессии Keycloak — молча возвращаем на форму входа.
    if (err === "login_required" || err === "interaction_required") {
      router.replace(PAGES.login);
      return;
    }
    error.value = err;
    loading.value = false;
    setTimeout(() => router.push(PAGES.login), 3000);
    return;
  }
  if (access && refresh) {
    cookiesServiceInstance.setToken({ access, refresh, auth_type: "keycloak" });
    appStore.setAuth();
    appStore.getUserData();
    appStore.getCitiesData();
    const dest = params.dest;
    const safe =
      dest &&
      dest.startsWith("/") &&
      !dest.startsWith("//") &&
      !dest.startsWith(PAGES.login) &&
      !dest.startsWith(PAGES.loginKeycloakCallback)
        ? dest
        : PAGES.main;
    router.replace(safe);
  } else {
    error.value = "Нет токенов от сервера.";
    loading.value = false;
    setTimeout(() => router.push(PAGES.login), 3000);
  }
});
</script>

<style scoped lang="scss">
.keycloak-callback {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;

  &__error {
    color: #c62828;
    margin-top: 16px;
    text-align: center;
  }
}
</style>
